import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  defaultData: any = { 
    action: 'success' ,
    hasBtn: true,
    multiBtn: false,
    title: '',
    message: '' 
   }

  constructor(public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      action: string ,
      hasBtn: boolean,
      multiBtn: boolean,
      title: string,
      message: string 
     }) {
      this.data = { ...this.defaultData, ...data };
     }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close('confirm'); 
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }
}
